export default {
  formattedPrice() {
    const value = Number(this.form.price) || 0;
    return value ? value.toLocaleString() : "";
  },
};
